import Vue from 'vue'
import noteApi from '@/api/note.api'


const state = {
  notes: {}
}


const getters = {
  notes: (state) => {
    return Object.values(state.notes) || []
  },

  noteTitles: (state) => {
    return Object.values(state.notes).map(note => note.title) || []
  },

  noteById: (state) => (id) => {
    return state.notes[id] || null
  }
}


const actions = {
  async loadNotes ({ commit, rootState }) {
    const projectId = rootState.project.currentId
    const response = await noteApi.getNotes(rootState.tenant.current, projectId)
    commit('SET_NOTES', { projectId, notes: response.data })
  },

  async loadNoteById ({ rootState }, params) {
    params.projectId = rootState.project.currentId
    const response = await noteApi.getNoteById(rootState.tenant.current, params)
    return response.data
  },

  // async loadNoteByNoteData ({ rootState }, noteData) {
  //   const params = {
  //     id: noteData.id,
  //     projectId: noteData.projectId
  //   }
  //   const response = await noteApi.getNoteById(rootState.tenant.current, params)
  //   return response.data
  // },

  // async updateNoteByNoteData ({ commit }, noteData) {
  //   commit('UPDATE_NOTE', noteData)
  // },

  async loadAndUpdateNote ({ commit, dispatch, rootState }, entityData) {
    const params = {
      projectId: entityData.projectId,
      id: entityData.entityId
    }
    const response = await noteApi.getNoteById(rootState.tenant.current, params)
    commit('UPDATE_NOTE', response.data)
    return response.data
  },

  async createNote ({ commit, rootState }, params) {
    // params = {
    //   "projectId": "string",
    //   "title": "string",
    //   "text": "string"
    // }
    params.projectId = rootState.project.currentId
    const response = await noteApi.createNote(rootState.tenant.current, params)
    commit('CREATE_NOTE', response.data)
    return response.data
  },

  async updateNote ({ commit, rootState }, params) {
    // params = {
    //   "projectId": "string",
    //   "id": "string",
    //   "title": "string",
    //   "text": "string"
    // }
    params.projectId = rootState.project.currentId
    const response = await noteApi.updateNote(rootState.tenant.current, params)
    commit('UPDATE_NOTE', response.data)
    return response.data
  },

  async deleteNote ({ commit, rootState }, params) {
    // params = {
    //   "projectId": "string",
    //   "id": "string",
    // }
    params.projectId = rootState.project.currentId
    await noteApi.deleteNote(rootState.tenant.current, params)
    commit('DELETE_NOTE', params.id)
  }
}


const mutations = {
  SET_NOTES (state, { projectId, notes }) {
    for (const id in state.notes) {
      if (state.notes[id].projectId === projectId) {
        Vue.delete(state.notes, id)
      }
    }

    for (const note of notes) {
      Vue.set(state.notes, note.id, note)
    }
  },

  CREATE_NOTE (state, note) {
    Vue.set(state.notes, note.id, note)
  },

  UPDATE_NOTE (state, note) {
    Vue.set(state.notes, note.id, note)
  },

  DELETE_NOTE (state, id) {
    Vue.delete(state.notes, id)
  }
}


export default {
  state,
  getters,
  actions,
  mutations
}
